var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "suggestions" }, [
    _vm.$store.state.webNavigator == "pc"
      ? _c("div", [
          _c(
            "div",
            { staticClass: "suggestions-bar" },
            [
              _vm._m(0),
              _c(
                "el-form",
                {
                  ref: "form",
                  staticClass: "suggestions-from",
                  attrs: { rules: _vm.rules, model: _vm.formData }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "选择反馈类型：", prop: "type" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择反馈类型" },
                          model: {
                            value: _vm.formData.type,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "type", $$v)
                            },
                            expression: "formData.type"
                          }
                        },
                        [
                          _c("el-option", { attrs: { value: "服务投诉" } }, [
                            _vm._v("服务投诉")
                          ]),
                          _c("el-option", { attrs: { value: "产品使用" } }, [
                            _vm._v("产品使用")
                          ]),
                          _c("el-option", { attrs: { value: "订单支付" } }, [
                            _vm._v("订单支付")
                          ]),
                          _c("el-option", { attrs: { value: "平台体验" } }, [
                            _vm._v("平台体验")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "请详细描述您的建议、意见、问题等：",
                        prop: "content",
                        id: "problem"
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          maxlength: "200",
                          placeholder: "必填 (200字内)"
                        },
                        model: {
                          value: _vm.formData.content,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "content", $$v)
                          },
                          expression: "formData.content"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "upload-demo",
                          attrs: {
                            action: _vm.upload,
                            "on-remove": _vm.handleRemove,
                            "on-success": _vm.handleSuccess,
                            "before-upload": _vm.beforeAvatarUpload,
                            "list-type": "picture",
                            multiple: "",
                            limit: 9,
                            "file-list": _vm.fileList
                          }
                        },
                        [
                          _c("span", { staticClass: "col666666 font8px" }, [
                            _vm._v("上传相关购买截图 :   ")
                          ]),
                          _c(
                            "el-button",
                            {
                              staticClass:
                                "suggestions-button suggestions-input-minBut",
                              attrs: { type: "primary" }
                            },
                            [_vm._v("点击上传")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("div", { staticClass: "col666666 suggestions-tip" }, [
                    _vm._v(
                      "请填写以下联系方式，方便我们及时回复您的建议、意见、问题！"
                    )
                  ]),
                  _c(
                    "div",
                    { staticClass: "suggestions-inputBox" },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            {
                              staticClass: "suggestions-rightBox",
                              attrs: { span: 12 }
                            },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "suggestions-inputBox-p",
                                  attrs: {
                                    prop: "name",
                                    label: "姓名：",
                                    id: "name"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: _vm.formData.name,
                                      callback: function($$v) {
                                        _vm.$set(_vm.formData, "name", $$v)
                                      },
                                      expression: "formData.name"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "suggestions-inputBox-p",
                                  attrs: {
                                    prop: "phone",
                                    label: "联系手机：",
                                    id: "phone"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { maxlength: "11" },
                                    model: {
                                      value: _vm.formData.phone,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "phone",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "formData.phone"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "suggestions-inputBox-p",
                                  attrs: { label: "客户编码：" }
                                },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: _vm.formData.crmCode,
                                      callback: function($$v) {
                                        _vm.$set(_vm.formData, "crmCode", $$v)
                                      },
                                      expression: "formData.crmCode"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "suggestions-inputBox-p2",
                                  attrs: { label: "称谓：" }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      model: {
                                        value: _vm.formData.title,
                                        callback: function($$v) {
                                          _vm.$set(_vm.formData, "title", $$v)
                                        },
                                        expression: "formData.title"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-option",
                                        {
                                          attrs: { value: "1", label: "先生" }
                                        },
                                        [_vm._v("先生")]
                                      ),
                                      _c(
                                        "el-option",
                                        {
                                          attrs: { value: "2", label: "女士" }
                                        },
                                        [_vm._v("女士")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c("div", {
                                staticClass: "popupShowAction",
                                attrs: { id: "CaptchaId" }
                              }),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "suggestions-inputBox-p2",
                                  attrs: {
                                    prop: "code2",
                                    label: "验证码：",
                                    id: "phonecode"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    staticClass: "suggestions-input-code",
                                    model: {
                                      value: _vm.formData.code2,
                                      callback: function($$v) {
                                        _vm.$set(_vm.formData, "code2", $$v)
                                      },
                                      expression: "formData.code2"
                                    }
                                  }),
                                  _c(
                                    "el-button",
                                    {
                                      staticClass:
                                        "suggestions-button suggestions-input-minBut",
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.getPicCode()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.timer
                                            ? _vm.count + "s"
                                            : "获取验证码"
                                        ) + "\n                "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass:
                                    "suggestions-inputBox-p2 suggestions-inputBox-time",
                                  attrs: {
                                    prop: "buyTime",
                                    label: "购买时间："
                                  }
                                },
                                [
                                  _c("el-date-picker", {
                                    attrs: {
                                      type: "datetime",
                                      placeholder: "请选择日期",
                                      "picker-options": _vm.pickerOptions1
                                    },
                                    model: {
                                      value: _vm.formData.buyTime,
                                      callback: function($$v) {
                                        _vm.$set(_vm.formData, "buyTime", $$v)
                                      },
                                      expression: "formData.buyTime"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "suggestions-buttonBox" },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            {
                              staticClass: "suggestions-buttonRight",
                              attrs: { span: 12 }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass:
                                    "suggestions-button suggestions-bigBut",
                                  on: {
                                    click: function($event) {
                                      return _vm.onSubmit()
                                    }
                                  }
                                },
                                [_vm._v("提交")]
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            {
                              staticClass: "suggestions-buttonLeft",
                              attrs: { span: 12 }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass:
                                    "suggestions-button suggestions-bigBut",
                                  on: {
                                    click: function($event) {
                                      return _vm.ChangeToList(2)
                                    }
                                  }
                                },
                                [_vm._v("我的投诉建议")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { attrs: { id: "code" } },
                [
                  _c(
                    "el-dialog",
                    {
                      staticClass: "suggestions-popup",
                      attrs: {
                        visible: _vm.dialogVisible3,
                        modal: true,
                        "close-on-click-modal": false,
                        "close-on-press-escape": false,
                        "show-close": false
                      },
                      on: {
                        "update:visible": function($event) {
                          _vm.dialogVisible3 = $event
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "codetitle content-advise-p" }, [
                        _vm._v("提示")
                      ]),
                      _c("div", { staticClass: "content-adviseBox" }, [
                        _c("span", { staticClass: "content-advise-p" }, [
                          _c(
                            "span",
                            {
                              staticClass: "marginleft2px content-advise-code"
                            },
                            [_vm._v("验证码 :")]
                          ),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.code1,
                                expression: "code1"
                              }
                            ],
                            staticClass: "content-advise-input marginleft5px",
                            domProps: { value: _vm.code1 },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.code1 = $event.target.value
                              }
                            }
                          })
                        ]),
                        _c("span", {
                          staticStyle: { "vertical-align": "middle" },
                          domProps: { innerHTML: _vm._s(this.picCode) },
                          on: {
                            click: function($event) {
                              return _vm.picCodeData()
                            }
                          }
                        })
                      ]),
                      _c(
                        "div",
                        { staticClass: "submitcode" },
                        [
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.close("1")
                                }
                              }
                            },
                            [_vm._v("取 消")]
                          ),
                          _c(
                            "el-button",
                            {
                              staticClass: "marginleft9px",
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.phoneCodeData()
                                }
                              }
                            },
                            [_vm._v("确 定")]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "div",
                { attrs: { id: "suc" } },
                [
                  _c(
                    "el-dialog",
                    {
                      attrs: {
                        visible: _vm.dialogVisible,
                        "show-close": false,
                        modal: true,
                        "close-on-click-modal": false,
                        "close-on-press-escape": false
                      },
                      on: {
                        "update:visible": function($event) {
                          _vm.dialogVisible = $event
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "dialog_time" }, [
                        _vm._v("(" + _vm._s(_vm.totalTime) + "S)")
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      : _c("div", [
          _c("div", { staticClass: "banner-advise-p marleft32px" }, [
            _vm._v(
              "\n      您如果对我们的产品和服务不满意，或者有好的建议，请您填写以下表格，我们的客服专员将会与您联系。\n    "
            )
          ]),
          _c("div", { staticClass: "phone-suggestions-from" }, [
            _c("div", { staticClass: "suggestions-inputBox-Box" }, [
              _c(
                "label",
                {
                  staticClass:
                    "phone-suggestions-ActLabel phone-suggestions-label"
                },
                [_vm._v("选择反馈类型：")]
              ),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.type,
                      expression: "formData.type"
                    }
                  ],
                  staticClass:
                    "phone-suggestions-select phone-suggestions-input",
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.formData,
                        "type",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                _vm._l(_vm.typeList, function(item, index) {
                  return _c(
                    "option",
                    {
                      key: index,
                      staticClass: "phone-suggestions-option",
                      domProps: {
                        value: item,
                        selected: index == 0 ? true : false
                      }
                    },
                    [_vm._v("\n            " + _vm._s(item) + "\n          ")]
                  )
                }),
                0
              )
            ]),
            _c(
              "div",
              { staticClass: "suggestions-inputBox-Box" },
              [
                _c(
                  "label",
                  {
                    staticClass:
                      "phone-suggestions-ActLabel phone-suggestions-label"
                  },
                  [_vm._v("请详细描述您的建议、意见、问题等11：")]
                ),
                _c("el-input", {
                  attrs: {
                    type: "textarea",
                    maxlength: "200",
                    "show-word-limit": ""
                  },
                  model: {
                    value: _vm.formData.content,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "content", $$v)
                    },
                    expression: "formData.content"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "suggestions-inputBox-Box" },
              [
                _c(
                  "el-upload",
                  {
                    staticClass: "phone-suggestions-upload",
                    attrs: {
                      action: _vm.upload,
                      "on-remove": _vm.handleRemove,
                      "on-success": _vm.handleSuccess,
                      "before-upload": _vm.beforeAvatarUpload,
                      "list-type": "picture",
                      multiple: "",
                      limit: 9,
                      "file-list": _vm.fileList
                    }
                  },
                  [
                    _c("span", { staticClass: "col666666 font24phone" }, [
                      _vm._v("上传相关购买截图 :   ")
                    ]),
                    _c(
                      "button",
                      {
                        staticClass:
                          "phone-suggestions-button phone-suggestions-minBut",
                        attrs: { type: "primary" }
                      },
                      [_vm._v("点击上传")]
                    )
                  ]
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col666666 phone-suggestions-tip font24phone" },
              [
                _vm._v(
                  "请填写以下联系方式，方便我们及时回复您的建议、意见、问题！"
                )
              ]
            ),
            _c("div", { staticClass: "phone-suggestions-inputBox" }, [
              _c("div", { staticClass: "suggestions-inputBox-p" }, [
                _c(
                  "label",
                  {
                    staticClass:
                      "phone-suggestions-ActLabel phone-suggestions-label"
                  },
                  [_vm._v("姓名：")]
                ),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.name,
                      expression: "formData.name"
                    }
                  ],
                  staticClass: "phone-suggestions-input",
                  attrs: { type: "text" },
                  domProps: { value: _vm.formData.name },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.formData, "name", $event.target.value)
                    }
                  }
                })
              ]),
              _c("div", { staticClass: "suggestions-inputBox-p" }, [
                _c("label", { staticClass: "phone-suggestions-label" }, [
                  _vm._v("称谓：")
                ]),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.formData.title,
                        expression: "formData.title"
                      }
                    ],
                    staticClass:
                      "phone-suggestions-select phone-suggestions-input",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.formData,
                          "title",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  [
                    _c(
                      "option",
                      {
                        staticClass: "phone-suggestions-option",
                        attrs: { value: "1", selected: "" }
                      },
                      [_vm._v("先生")]
                    ),
                    _c(
                      "option",
                      {
                        staticClass: "phone-suggestions-option",
                        attrs: { value: "2" }
                      },
                      [_vm._v("女士")]
                    )
                  ]
                )
              ]),
              _c("div", { staticClass: "suggestions-inputBox-p" }, [
                _c(
                  "label",
                  {
                    staticClass:
                      "phone-suggestions-ActLabel phone-suggestions-label"
                  },
                  [_vm._v("联系手机：")]
                ),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.number",
                      value: _vm.formData.phone,
                      expression: "formData.phone",
                      modifiers: { number: true }
                    }
                  ],
                  staticClass: "phone-suggestions-input",
                  attrs: { type: "text", maxlength: "11" },
                  domProps: { value: _vm.formData.phone },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.formData,
                        "phone",
                        _vm._n($event.target.value)
                      )
                    },
                    blur: function($event) {
                      return _vm.$forceUpdate()
                    }
                  }
                })
              ]),
              _c("div", { staticClass: "suggestions-inputBox-p" }, [
                _c(
                  "label",
                  {
                    staticClass:
                      "phone-suggestions-ActLabel phone-suggestions-label"
                  },
                  [_vm._v("验证码：")]
                ),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.code2,
                      expression: "formData.code2"
                    }
                  ],
                  staticClass: "suggestions-input-code",
                  domProps: { value: _vm.formData.code2 },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.formData, "code2", $event.target.value)
                    }
                  }
                }),
                _c(
                  "button",
                  {
                    staticClass:
                      "phone-suggestions-button phone-suggestions-minBut2",
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.getPicCode()
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.timer ? _vm.count + "s" : "验证码") +
                        "\n          "
                    )
                  ]
                )
              ]),
              _c("div", { staticClass: "suggestions-inputBox-p" }, [
                _c("label", { staticClass: "phone-suggestions-label" }, [
                  _vm._v("客户编码：")
                ]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.crmCode,
                      expression: "formData.crmCode"
                    }
                  ],
                  staticClass: "phone-suggestions-input",
                  attrs: { type: "text" },
                  domProps: { value: _vm.formData.crmCode },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.formData, "crmCode", $event.target.value)
                    }
                  }
                })
              ]),
              _c(
                "div",
                {
                  staticClass:
                    "suggestions-inputBox-p suggestions-inputBox-time"
                },
                [
                  _c("label", { staticClass: "phone-suggestions-label" }, [
                    _vm._v("购买时间：")
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.formData.buyTime,
                        expression: "formData.buyTime"
                      }
                    ],
                    staticClass: "phone-suggestions-input",
                    attrs: { type: "date" },
                    domProps: { value: _vm.formData.buyTime },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.formData, "buyTime", $event.target.value)
                      }
                    }
                  })
                ]
              )
            ]),
            _c("div", { staticClass: "suggestions-buttonBox" }, [
              _c(
                "button",
                {
                  staticClass:
                    "suggestions-button suggestions-bigBut bigBut-01",
                  on: {
                    click: function($event) {
                      return _vm.onSubmit()
                    }
                  }
                },
                [_vm._v("提交")]
              ),
              _c(
                "button",
                {
                  staticClass:
                    "suggestions-button suggestions-bigBut bigBut-02",
                  on: {
                    click: function($event) {
                      return _vm.ChangeToList(2)
                    }
                  }
                },
                [_vm._v("我的投诉建议")]
              )
            ])
          ]),
          _c(
            "div",
            { staticClass: "phone-popup-box" },
            [
              _c(
                "el-dialog",
                {
                  staticClass: "suggestions-popup",
                  attrs: {
                    visible: _vm.dialogVisible3,
                    modal: true,
                    "close-on-click-modal": false,
                    "close-on-press-escape": false,
                    "show-close": false
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.dialogVisible3 = $event
                    }
                  }
                },
                [
                  _c("div", { staticClass: "codetitle content-advise-p" }, [
                    _vm._v("提示")
                  ]),
                  _c("div", { staticClass: "content-adviseBox" }, [
                    _c("span", { staticClass: "content-advise-p" }, [
                      _c("span", { staticClass: "font30phone" }, [
                        _vm._v("验证码： ")
                      ]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.code1,
                            expression: "code1"
                          }
                        ],
                        staticClass: "content-advise-input marginleft5px",
                        domProps: { value: _vm.code1 },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.code1 = $event.target.value
                          }
                        }
                      })
                    ]),
                    _c("span", {
                      staticClass: "popup-pic",
                      staticStyle: { "vertical-align": "middle" },
                      domProps: { innerHTML: _vm._s(this.picCode) },
                      on: {
                        click: function($event) {
                          return _vm.picCodeData()
                        }
                      }
                    })
                  ]),
                  _c("div", { staticClass: "submitcode" }, [
                    _c(
                      "button",
                      {
                        staticClass: "content-advise-but but-01",
                        on: {
                          click: function($event) {
                            return _vm.close("1")
                          }
                        }
                      },
                      [_vm._v("取 消")]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "content-advise-but marginleft9px",
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.phoneCodeData()
                          }
                        }
                      },
                      [_vm._v("确 定")]
                    )
                  ])
                ]
              ),
              _c(
                "el-dialog",
                {
                  staticClass: "suggestions-popupBG",
                  attrs: {
                    visible: _vm.dialogVisible,
                    "show-close": false,
                    modal: true,
                    "close-on-click-modal": false,
                    "close-on-press-escape": false
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.dialogVisible = $event
                    }
                  }
                },
                [
                  _c("span", { staticClass: "dialog_time" }, [
                    _vm._v("(" + _vm._s(_vm.totalTime) + "S)")
                  ])
                ]
              )
            ],
            1
          )
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "suggestions-TltBox" }, [
      _c("div", { staticClass: "font36px suggestions-Tlt" }, [
        _vm._v("投诉建议")
      ]),
      _c("div", { staticClass: "content-advise-p" }, [
        _vm._v(
          "您如果对我们的产品、服务不满意，或者有好的建议，请您填写以下表格，除周六周日及法定节假日外，您所有的诉求，我们将在24小时内为您解答。\n        "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cf8afd08", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf8afd08","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/about/suggestions/suggestions.vue
// module id = 1210
// module chunks = 9